export default {"src":"/_next/static/media/close-icon.f77fb796.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};